module.exports = __webpack_public_path__ + "img/9-10-25.a1b4f618.jpg";